import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, useState } from 'react';
import { TableColumnHeader } from './TableColumnHeader';
export const TableHead = (props) => {
    const { table, children } = props;
    const [hoveredColumnId, setHoveredColumnId] = useState();
    return (_jsx(_Fragment, { children: table.getHeaderGroups().map((headerGroup) => (_jsxs(Fragment, { children: [children, headerGroup.headers.map((header, index) => (_jsx(TableColumnHeader, { index: index, header: header, isFirst: index === 0 && !children, isLast: headerGroup.headers.length === index + 1, setHoveredColumnId: setHoveredColumnId, hoveredColumnId: hoveredColumnId }, header.id)))] }, headerGroup.id))) }));
};
//# sourceMappingURL=TableHead.js.map